import script from "./ViewDynamicComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewDynamicComponent.vue?vue&type=script&setup=true&lang=js"

import "./ViewDynamicComponent.vue?vue&type=style&index=0&id=2fef63ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fef63ec"]])

export default __exports__